<template>

    <div v-if="isLoggedIn && getToken !== null" class="site-container">
        <!-- Normal application view -->
        <SuccessBar :message="getSuccessBarMessage"></SuccessBar>
        <div class="app__expire-support-notification">
            <div>
                Rently understøttes ikke længere fra den 1. januar 2023. Opret dig på vores nye gratis platform
                <a href="https://rentdesk.dk" target="_blank" rel="norefferer nooppener">www.rentdesk.dk</a>
                for at lave nye lejekontrakter og flyttesyn (dine Rently data vil blive overført til din Rentdesk konto på et senere tidspunkt).
            </div>
        </div>
        <sidebar></sidebar>
        <div class="page-content">
            <router-view></router-view>
        </div>
    </div>
    <div v-else-if="isLoggedIn && getToken === null" class="site-container">
        <!-- Popup Form view -->
        <GlobalLoginForm ref="globalLoginForm"/>
    </div>
    <div v-else-if="!isLoggedIn && getToken === null" class="site-container">
        <!-- Full Page view for login page -->
        <div class="lang-switcher">
            <select v-model="language">
                <option value="dk">Da</option>
                <option value="en">Eng</option>
            </select>
            <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 20 11.97">
                      <path class="fill-purple"
                            d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z"
                            transform="translate(-3241 -2084.03)"/>
                    </svg>
                </span>
        </div>
        <div class="page-content login-page">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>

import {mapGetters} from 'vuex'
import Sidebar from './components/Sidebar'
import Vue from 'vue'
import SuccessBar from './components/SuccessBar';
import GlobalLoginForm from './components/GlobalLoginForm';
import SvgIcon from './components/Svg';
import Modal from './components/Modal';
import VueWoopra from 'vue-woopra';
import VueGtag from "vue-gtag";
import TurnOffAutocomplete from 'vue-turn-off-autocomplete';

import 'es6-promise/auto';

//
const {detect} = require('detect-browser');
const browser = detect();

Vue.component('Modal', Modal);
Vue.component('SvgIcon', SvgIcon)

Vue.use(TurnOffAutocomplete);

if (window.config.environment === 'production') {
    Vue.use(VueGtag, {
        config: {
            id: 'UA-128965323-1',
            params: {
                send_page_view: true
            }
        }
    });
    gtag('config', 'G-BMHDLLSLE0');
    Vue.use(VueWoopra, {configs: {domain: 'app.rently.dk'}});
} else {
    Vue.use(VueGtag, {config: {id: 'G-KH5N0QRG0J'}});
}

export default {
    components: {
        Sidebar,
        SuccessBar,
        GlobalLoginForm,
    },
    computed: {
        ...mapGetters([
            'getToken',
            'getSuccessBarMessage',
            'isLoggedIn'
        ])
    },
    data: () => ({
        language: 'dk'
    }),
    mounted() {
        if (typeof woopra != 'undefined' && this.isLoggedIn) {
            woopra.track();
        }

        const storedLanguage = window.localStorage.getItem('language');

        if (storedLanguage !== null) {
            this.language = storedLanguage;
        }

        Vue.i18n.set(this.language);
    },
    watch: {
        $route: {
            handler(date) {
                if (typeof woopra != 'undefined' && this.isLoggedIn) {
                    woopra.track();
                }
            },
            deep: true
        },
        language(val) {
            Vue.i18n.set(val);
            window.localStorage.setItem('language', val);
        }
    },
    created() {
        axios.interceptors.request.use(request => {
            const token = this.$store.getters.getToken;

            if ((request.url.includes('rently') || request.url.includes('localhost')) && token) {
                request.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                request.headers.common['Authorization'] = `Bearer ${token}`;
            }

            return request;
        });

        axios.interceptors.response.use(response => response, error => {

            if (axios.isCancel(error)) {
                console.log('Request canceled', error.message);
            }

            if (error.response && (error.response.status === 401 || error.response.status === 403)) {

                // We have no valid token now, but we assume we are still logged
                // This is a state when Popup form should be displayed
                this.$store.commit('setToken', null);
                window.AuthorizationCancelSource.cancel(error.response.data);
            }

            let messages = error.response.data.error.errors;

            if (messages) {
                messages = _.map(messages, errors => errors.join('<br>')).join('<br>')
            }

            this.$swal(error.response.data.error.message, messages, 'error');

            return Promise.reject(error)
        })
    }
}
</script>
<style>
.app__expire-support-notification {
    position: fixed;
    height: 48px;
    z-index: 99999;
    background: #ffdb43;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    font-family: HankenGroteskSemiBold,HankenGroteskSemiBoldOld,HelveticaNeue,Helvetica,Arial,sans-serif;
    padding: 0 16px;
}
</style>
